import { useLocation, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@hooks/useStore';
import { MyFC } from '@/types/common';
import { RouteProps } from './types';
import { getToken } from '@/utils/tokenUtils';

export const CustomRoute: MyFC<RouteProps> = observer(({ isPrivate, children }) => {
  const {
    profileStore: { redirectUrl, user },
    // authStore: { setAuthStep },
  } = useStore();

  const location = useLocation();
  const token = getToken();

  if (isPrivate && !token) {
    return <Navigate to="/login" replace />;
    // } else if (token && (location.pathname === '/login' || location.pathname === '/')) {
  } else if (
    token &&
    user?.role === 'business' &&
    (location.pathname === '/login' || location.pathname === '/') &&
    user?.isAgreedPolicy
  ) {
    return <Navigate to={redirectUrl} replace />;
  } else if (
    token &&
    user?.role === 'customer' &&
    location.pathname === '/login' &&
    user?.isAgreedPolicy
  ) {
    return <Navigate to={'/'} replace />;
  } else {
    return <>{children}</>;
  }
});
